import React from 'react';
import { ImLocation,ImFacebook } from 'react-icons/im';
import {
  BsFillTelephoneFill,BsGlobe,BsFillClockFill,BsGoogle,BsInstagram,BsTwitter,
} from 'react-icons/bs';

const SelfDescription = ({ data }) => (
  <div>
    <div className="space-y-4 text-sm text-slate-600">
      <div className="flex items-start space-x-3 leading-relaxed text-slate-700">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-slate-50 ring-1 ring-slate-200"> 
          {' '}
          <ImLocation className="text-red-600" />
          {' '}
        </span>
        <span className="pt-1">
          {' '}
          {data?.address?.street_address} 
          {' | '}
          {data?.address?.apartment_or_suite}
          {data?.address?.city} 
          {' | '}
          {data?.address?.state_or_province} 
          {' '}
          {data?.address?.country}
        </span>
      </div>

      <div className="flex items-center space-x-3">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-slate-50 ring-1 ring-slate-200"> 
          {' '}
          <BsFillTelephoneFill className="text-blue-800" />
          {' '}
        </span>
        <span>
          {' '}
          {data?.company?.phone_number ?? 'Not Available'}
        </span>
      </div>
      <div className="flex items-center space-x-3">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-slate-50 ring-1 ring-slate-200"> 
          {' '}
          <BsGlobe className="text-gray-700" />
          {' '}
        </span>
        <span className={data?.website ? 'min-w-0 break-all text-blue-600 hover:cursor-pointer hover:text-blue-700 hover:underline' : ''}>
          {' '}
          {data?.website ? <a href={data?.website}>{data?.website}</a> : 'Not Available' }
        </span>
      </div>
      <div className="flex items-center space-x-3">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-slate-50 ring-1 ring-slate-200"> 
          {' '}
          <BsFillClockFill className="text-gray-400" />
          {' '}
        </span>
        <span>
          {' '}
          By Appointment Only
        </span>
      </div>
    </div>
  </div>
);

export default SelfDescription;
